// extracted by mini-css-extract-plugin
module.exports = {"container":"_2f-94l"};